import React, { useMemo, useCallback } from 'react'

import { useDialog } from '@galo-monitor/dialog'
import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import DataTable from '@galo-monitor/web-components/DataTable'
import Screen from '@galo-monitor/web-components/Screen'
import BreederModal from '@galo-monitor/web-containers/modals/root/BreederModal'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

const Breeders = () => {
  const t = useT()
  const { createDialog } = useDialog()
  const { routes, getActionsBySlug } = useRoutes()

  const { data: breeders, mutate, isValidating } = useGaloMonitorApi('/admin/breeders')

  const userActions = useMemo(
    () => getActionsBySlug(routes.cultivars.slug),
    [getActionsBySlug, routes.cultivars.slug]
  )

  const columns = useMemo(
    () => [
      {
        title: t('name'),
        field: 'name'
      }
    ],
    [t]
  )

  const onAddClick = useCallback(
    () => {
      createDialog({
        id: 'create-breeder',
        Component: BreederModal,
        props: {
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  const onEditClick = useCallback(
    (_, breeder) => {
      createDialog({
        id: 'edit-breeder',
        Component: BreederModal,
        props: {
          breeder,
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  const crumbs = useMemo(() => [
    {
      title: t('breeder', { howMany: 2 }),
      key: 'breeders-screen',
      url: '/cultivars/breeders',
      active: true
    }
  ], [t])

  return (
    <Screen breadcrumbs={ crumbs }>
      <DataTable
        loading={ isValidating }
        data={ breeders || [] }
        columns={ columns }
        onAddClick={ userActions.write && onAddClick }
        onEditClick={ userActions.edit && onEditClick }
      />
    </Screen>
  )
}

export default Breeders
